import React from 'react';
import { useFilterStore } from '../../stores/useFilterStore';

/**
 * Visible count of wallets the intermediate (Tier-3) filter has stashed, with
 * a one-click way back. Renders nothing when nothing is hidden by that filter.
 *
 * Package 8: after a run the filter used to hide unattributed hop-2 wallets,
 * the layering wallets an officer most needs, with no sign it had. This keeps
 * the number in view next to the Filters control and in the filter panel.
 */
export const HiddenByTierNotice: React.FC<{ className?: string }> = ({ className }) => {
    const hidden = useFilterStore(s => s.filterCounts.hiddenByTier ?? 0);
    const mergeGraphFilters = useFilterStore(s => s.mergeGraphFilters);
    if (hidden <= 0) return null;
    return (
        <span
            data-testid="hidden-by-tier-notice"
            className={
                'inline-flex items-center gap-1.5 rounded-md border border-amber-500/40 bg-amber-500/10 '
                + 'px-2 py-0.5 text-xs text-amber-900 dark:text-amber-200 ' + (className ?? '')
            }
            role="status"
        >
            <span>
                {hidden} wallet{hidden === 1 ? '' : 's'} hidden by the intermediate filter
            </span>
            <button
                type="button"
                data-testid="hidden-by-tier-show-all"
                className="font-semibold underline underline-offset-2 hover:no-underline"
                onClick={() => mergeGraphFilters({
                    showAllNodes: true,
                    showIntermediateNodes: true,
                    tierFilterChosen: true,
                })}
            >
                show all
            </button>
        </span>
    );
};

export default HiddenByTierNotice;
